(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("moment-mini"), require("vue"), require("urijs"));
	else if(typeof define === 'function' && define.amd)
		define("Kamala", ["jquery", "moment-mini", "vue", "urijs"], factory);
	else if(typeof exports === 'object')
		exports["Kamala"] = factory(require("jquery"), require("moment-mini"), require("vue"), require("urijs"));
	else
		root["Kamala"] = factory(root["jQuery"], root["moment"], root["Vue"], root["URI"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__281__) {
return 